import React from 'react';
import { Grid, Typography, Link } from "@material-ui/core";
import '../../App.css'
import {  ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import workClasses from './workStyles.js'
import { Link as RouterLink } from 'react-router-dom';


function OurWorkCaseStudies() {
  const globalClasses = globalUseStyles()
  const workStyles = workClasses()
  return (
    <ThemeProvider theme={theme}>
        <Container  className={globalClasses.standardContainer} maxWidth={false} component="section">
            <Grid id='casestudies'className={globalClasses.containerSmall} container >
                <Grid item xs={12} md={12}  >
                    <Typography  variant="subtitle1">What We've Done</Typography>
                    <Typography  variant="h2">Featured Case Studies</Typography>
                </Grid>
            </Grid>
            <Grid className={globalClasses.containerSmall} container >
                <Grid item className={globalClasses.topBottomSpacing} xs={12} md={5}  >
                    <Grid item xs={12} md={12} className={workStyles.rciImg} />
                    <Grid className={globalClasses.textBlockBelow} item xs={12} md={12}  >
                    <div className={workStyles.tagYellow}>
                        <Typography variant="subtitle2">Custom Application</Typography>
                    </div>
                    <div className={workStyles.tagYellow}>
                        <Typography variant="subtitle2">Reporting and Analytics</Typography>
                    </div>
                    </Grid>
                    <Grid className={globalClasses.textBlockBelowSm} item xs={12} md={12}  >
                    <Typography className={globalClasses.cardMargin} variant="h4">The Rosalyn Carter Institute for Caregivers (RCI)</Typography>
                    <Typography variant="body1">The Rosalyn Carter Institute for Caregivers (RCI) promotes the health, strength, and resilience of caregivers at every stage of their journey. We developed a caregiver management system to document and report on the caregiver experience with RCI across every program and touchpoint. </Typography>
                    <Typography variant="body1" >
                        <Link to='/case' className={"link link--arrowed"} color="primary" component={RouterLink}>View Case Study
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                         </Link>
                    </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={false} md={2}  />
                <Grid item className={globalClasses.topBottomSpacing} xs={12} md={5}  >
                    <Grid item xs={12} md={12} className={workStyles.ashaImg} />
                    <Grid className={globalClasses.textBlockBelow} item xs={12} md={12}>
                    <div className={workStyles.tagYellow}>
                        <Typography variant="subtitle2">Custom Application</Typography>
                    </div>
                    <div className={workStyles.tagYellow}>
                        <Typography variant="subtitle2">Reporting and Analytics</Typography>
                    </div>
                    </Grid>
                    <Grid className={globalClasses.textBlockBelowSm} item xs={12} md={12}  >
                    <Typography className={globalClasses.cardMargin} variant="h4">ASHA’s National Outcomes Measurement System (NOMS)</Typography>
                    <Typography variant="body1">ASHA NOMS is a data collection and reporting system that demonstrates the value of Speech-Language Pathology and audiology services. Integrated with EHRs, this tool allows providers to track progress in patients and aggregates data so that the field can make informed decisions on patient outcomes. </Typography>
                    <Typography variant="body1" >
                        <Link to='/case' className={"link link--arrowed"} color="primary" component={RouterLink}>View Case Study
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                         </Link>
                    </Typography>
                    </Grid>
                </Grid>
                <Grid item className={globalClasses.topBottomSpacing} xs={12} md={5}  >
                    <Grid item xs={12} md={12} className={workStyles.ahrqImg2} />
                    <Grid className={globalClasses.textBlockBelow} item xs={12} md={12}  >
                    <div className={workStyles.tagYellow}>
                        <Typography variant="subtitle2">Custom Application</Typography>
                    </div>
                    <div className={workStyles.tagYellow}>
                        <Typography variant="subtitle2">Reporting and Analytics</Typography>
                    </div>
                    </Grid>
                    <Grid className={globalClasses.textBlockBelowSm} item xs={12} md={12}  >
                    <Typography className={globalClasses.cardMargin} variant="h4">Agency for Healthcare Research and Quality: Quality Indicators (QI) </Typography>
                    <Typography  variant="body1">AHRQ’s Quality Indicators (QI) are measures of health care quality that make use of readily available hospital administrative data and are used by organizations with the support of a Windows based software (WinQI) or SAS (SAS QI) software. </Typography>
                    <Typography variant="body1" >
                        <Link to='/case' className={"link link--arrowed"} color="primary" component={RouterLink}>View Case Study
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                         </Link>
                    </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={false} md={2}  />
                <Grid item className={globalClasses.topBottomSpacing} xs={12} md={5}  >
                    <Grid item xs={12} md={12} className={workStyles.ahrqImg} />
                    <Grid className={globalClasses.textBlockBelow} item xs={12} md={12}>
                    <div className={workStyles.tagYellow}>
                        <Typography variant="subtitle2">Custom Application</Typography>
                    </div>
                    <div className={workStyles.tagYellow}>
                        <Typography variant="subtitle2">Reporting and Analytics</Typography>
                    </div>
                    </Grid>
                    <Grid className={globalClasses.textBlockBelowSm} item xs={12} md={12}  >
                    <Typography className={globalClasses.cardMargin} variant="h4">Agency for Healthcare Research and Quality: Patient Safety Network (PSNet) </Typography>
                    <Typography variant="body1">The PSNet website a one-stop-shop for research in the field of patient safety, both aggregating content from other academic sites as well as producing its own expert content in the field.  </Typography>
                    <Typography variant="body1" >
                        <Link to='/case' className={"link link--arrowed"} color="primary" component={RouterLink}>View Case Study
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                         </Link>
                    </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    </ThemeProvider>
  );
};

export default OurWorkCaseStudies;